import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {Box, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField} from "../../utils/ui";
import {
    fetchFolders,
    fetchLists,
    fetchSpaces,
    getAccessToken,
    getFolders, getLists,
    getSpaces,
    setConfigList
} from "./configSlice";

const defaultConfig = {
    name: "",
    team: {
        id: "",
        name: "",
    },
    space: {
        id: "",
        name: "",
    },
    folder: {
        id: "",
        name: "",
    },
    list: {
        id: "",
        name: "",
    },
    isDefault: false,
    time: new Date().getTime()
};

const listObj = {
    id: "folder_less",
    name: "Folder less List",
};
export default function AddEditConfig({selectedConfig, configList, isForUpdate, isCloned, teams, closedAddConfig}) {

    const [config, setConfig] = useState(isForUpdate || isCloned ? configList[selectedConfig] : defaultConfig);
    const [showFormError, setShowFormError] = useState(false);
    const dispatch = useDispatch();
    const spaces = useSelector(getSpaces);
    const folders = useSelector(getFolders);
    const lists = useSelector(getLists);
    const token = useSelector(getAccessToken);

    useEffect(() => {
        if (!isForUpdate && !isCloned)
            return;

        if (config.team.id)
            dispatch(fetchSpaces({token, teamId: config.team.id}));

        if (config.space.id)
            dispatch(fetchFolders({token, spaceId: config.space.id}));

        if (config.space.id)
            dispatch(fetchFolders({token, spaceId: config.space.id}));

        if (config.folder.id) {
            if(config.folder.id === listObj.id)
                dispatch(fetchLists({token, spaceId: config.space.id}));
            else
                dispatch(fetchLists({token, folderId: config.folder.id}));
        }

    }, [isForUpdate, isCloned]);

    function onSubmit(e) {
        e.preventDefault();
        if (!config.name || !config.team.name || !config.space.name || !config.folder.name || !config.list.name) {
            setShowFormError(true);
            return;
        }

        let tempList = configList && Array.isArray(configList) ? [...configList] : [];

        if (isForUpdate) {
            tempList[selectedConfig] = config;
            dispatch(setConfigList(tempList));
        } else {
            tempList.unshift(config);
            dispatch(setConfigList(tempList));
        }
        closedAddConfig();
    }

    function updateValue(e, key) {
        const tempConfig = {...config};
        if (key === 'team') {
            const teamId = e.target.value?.id;
            if (tempConfig.team.id === teamId)
                return;

            tempConfig.team = e.target.value;
            tempConfig.space = {id: "", name: ""};

            if (!spaces[teamId])
                dispatch(fetchSpaces({token, teamId}));
        } else if (key === 'space') {
            const spaceId = e.target.value?.id;

            if (tempConfig.space.id === spaceId)
                return;

            tempConfig.space = e.target.value;
            tempConfig.folder = {id: "", name: ""};
            if (!folders[spaceId])
                dispatch(fetchFolders({token, spaceId}));
        } else if (key === 'folder') {
            const folderId = e.target.value?.id;

            if (tempConfig.folder.id === folderId)
                return;
            tempConfig.folder = e.target.value;
            tempConfig.list = {id: "", name: ""};
            if (!lists[folderId]) {
                if (folderId === listObj.id)
                    dispatch(fetchLists({token, spaceId: tempConfig.space.id}));
                else
                    dispatch(fetchLists({token, folderId}));
            }

        } else if (key === 'list') {
            const listId = e.target.value?.id;
            if (tempConfig.list.id === listId)
                return;

            tempConfig.list = e.target.value;
        } else {
            tempConfig.name = e.target.value;
        }
        setConfig(tempConfig);
    }
    let selectedList = [];
    if(lists[config.folder?.id] && Array.isArray(lists[config.folder?.id]))
        selectedList = lists[config.folder?.id];
    else if(lists[config.space?.id] && Array.isArray(lists[config.space?.id]))
        selectedList = lists[config.space?.id];

    return (
        <Box
            onSubmit={onSubmit}
            className="mappingContainer"
            autoComplete="off"
            noValidate
            component="form">
            <TextField
                error={showFormError && !config.name}
                onChange={updateValue}
                className="fieldInput"
                id="outlined-basic"
                label="Name"
                variant="outlined"
                value={config.name}
                helperText={showFormError && !config.name ? "Required" : ""}
            />
            <FormControl className="fieldInput" error={showFormError && !config.team.name}>
                <InputLabel id="demo-simple-select-error-label">Select Team (Workspace)</InputLabel>
                <Select
                    labelId="demo-simple-select-error-label"
                    id="demo-simple-select-error"
                    value={config.team.name}
                    label="Select Team (Workspace)"
                    renderValue={(value) => `${value}`}
                    onChange={e => updateValue(e, "team")}
                >
                    {
                        teams.map(t => (
                            <MenuItem key={t.id} value={t}>
                                <em>{t.name}</em>
                            </MenuItem>
                        ))
                    }
                </Select>
                {showFormError && !config.team.name && <FormHelperText>Required</FormHelperText>}
            </FormControl>
            <FormControl className="fieldInput" error={showFormError && !config.space.name}>
                <InputLabel id="demo-simple-select-error-label">Select Space</InputLabel>
                <Select
                    labelId="demo-simple-select-error-label"
                    id="demo-simple-select-error"
                    value={config.space.name}
                    label="Select Space"
                    renderValue={(value) => `${value}`}
                    onChange={e => updateValue(e, "space")}
                >
                    {
                        spaces[config.team?.id]?.map(s => (
                            <MenuItem key={s.id} value={s}>
                                <em>{s.name}</em>
                            </MenuItem>
                        ))
                    }
                </Select>
                {showFormError && !config.space.name && <FormHelperText>Required</FormHelperText>}
            </FormControl>
            <FormControl className="fieldInput" error={showFormError && !config.folder.name}>
                <InputLabel id="demo-simple-select-error-label">Select Folder</InputLabel>
                <Select
                    labelId="demo-simple-select-error-label"
                    id="demo-simple-select-error"
                    value={config.folder.name}
                    label="Select Space"
                    renderValue={(value) => `${value}`}
                    onChange={e => updateValue(e, "folder")}
                >
                    <MenuItem key={listObj.id} value={listObj}>
                        <em>{listObj.name}</em>
                    </MenuItem>
                    {
                        folders[config.space?.id]?.map(f => (
                            <MenuItem key={f.id} value={f}>
                                <em>{f.name}</em>
                            </MenuItem>
                        ))
                    }
                </Select>
                {showFormError && !config.folder.name && <FormHelperText>Required</FormHelperText>}
            </FormControl>
            <FormControl className="fieldInput" error={showFormError && !config.list.name}>
                <InputLabel id="demo-simple-select-error-label">Select Lists</InputLabel>
                <Select
                    labelId="demo-simple-select-error-label"
                    id="demo-simple-select-error"
                    value={config.list.name}
                    label="Select Space"
                    renderValue={(value) => `${value}`}
                    onChange={e => updateValue(e, "list")}
                >
                    {
                        selectedList.map(l => (
                            <MenuItem key={l.id} value={l}>
                                <em>{l.name}</em>
                            </MenuItem>
                        ))
                    }
                </Select>
                {showFormError && !config.list.name && <FormHelperText>Required</FormHelperText>}
            </FormControl>
            <div className="fieldInput">
                <Button type="submit" className="submitBtn" size="large" variant="contained"
                        color="success">
                    Save
                </Button>
            </div>
            <div className="fieldInput">
                <Button className="submitBtn" size="large" variant="outlined"
                        onClick={closedAddConfig}
                        color="error">
                    Cancel
                </Button>
            </div>
        </Box>
    )
}